import { FC, memo } from "react";

interface CrossProps {
  size?: number;
}

const Cross: FC<CrossProps> = ({ size = 18 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.0165 4.7335C5.48777 4.26223 6.25184 4.26223 6.72311 4.7335L9.28301 7.2934L11.8429 4.7335C12.3142 4.26223 13.0782 4.26223 13.5495 4.73349C14.0208 5.20476 14.0208 5.96883 13.5495 6.4401L10.9896 9L13.5495 11.5599C14.0208 12.0312 14.0208 12.7952 13.5495 13.2665C13.0782 13.7378 12.3142 13.7378 11.8429 13.2665L9.28301 10.7066L6.72311 13.2665C6.25184 13.7378 5.48777 13.7378 5.0165 13.2665C4.54524 12.7952 4.54524 12.0312 5.0165 11.5599L7.57641 9L5.0165 6.4401C4.54524 5.96883 4.54524 5.20476 5.0165 4.7335Z"
          fill="#757575"
          stroke="#F3FFFE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default memo(Cross);
